import * as React from "react";

export interface IConfigurationHelpProps {
    type: string
}


export default class ConfigurationHelp extends React.Component<IConfigurationHelpProps, any> {

    constructor() {
        super();

        this.state = {
            isAPIDoc: true
        }
    }

    toJson(obj: any) {
        return JSON.stringify(obj, null, 2);
    }

    handleTabClick(isAPIDoc: boolean, e: any) {
        e.preventDefault();

        var newState = $.extend({}, this.state, { isAPIDoc: isAPIDoc });
        this.setState(newState);
    }

    render() {
        var data = {
            Activate: {
                APIDoc: {
                    Request: {
                        "MerchantId": "0123456789AB",
                        "TerminalId": "0015",
                        "AuditNumber": "0001",
                        "EntryMode": "track1",
                        "CardPresence": "present",
                        "Account": "7777004512345678",
                        "Amount": 100.25,
                        "ExpirationDate": "0119"
                    },
                    Response: {
                        "Message": "APPROVED",
                        "AuditNumber": "0001",
                        "AuthorizationNumber": "123459",
                        "TransactionId": "00002352341",
                        "AuthorizedAmount": 100.25,
                        "Balance": 100.25
                    }
                },
                Examples: [{
                    Header: 'Return error ACCT_CLOSED',
                    Json: {
                        "Error": {
                            "Message": "This gift card account has been closed",
                            "Code": "ACCT_CLOSED"
                        },
                        "AuthorizedAmount": 0,
                        "Balance": 100.25,
                        "TransactionId": "[GEN_STRING_15]"
                    }
                }, {
                        Header: 'Success - copy AuditNumber and Amount, generate rest',
                        Json: {
                            "Message": "APPROVED",
                            "AuditNumber": "[COPY]",
                            "AuthorizationNumber": "[GEN_STRING_8]",
                            "TransactionId": "[GEN_STRING_15]",
                            "AuthorizedAmount": "[AMOUNT]",
                            "Balance": 100.25
                        }
                    }, {
                        Header: 'Return error ALREADY_ACTIVE',
                        Json: {
                            "Error": {
                                "Message": "Gift card already active",
                                "Code": "ALREADY_ACTIVE"
                            },
                            "AuthorizedAmount": 0,
                            "Balance": 100.25,
                            "TransactionId": "[GEN_STRING_15]"
                        }
                    }]
            },
            Redeem: {
                APIDoc: {
                    Request: {
                        "MerchantId": "0123456789AB",
                        "TerminalId": "0015",
                        "AuditNumber": "0002",
                        "EntryMode": "track1",
                        "CardPresence": "present",
                        "TrackData": "B6010123456789012^TEST GIFT CARD^00010004000070002886",
                        "Amount": 10,
                        "AllowPartialRedemption": true,
                        "Type": "Sale",
                        "ExpirationDate": "0119"
                    },
                    Response: {
                        "Message": "APPROVED",
                        "AuditNumber": "0002",
                        "AuthorizationNumber": "123459",
                        "TransactionId": "00002352342",
                        "Balance": 100.25,
                        "AuthorizedAmount": 5.50,
                        "Account": "7777004512345678"
                    }
                },
                Examples: [{
                    Header: 'Success - always authorize 10',
                    Json: {
                        "Message": "APPROVED",
                        "Balance": 100.25,
                        "AuthorizedAmount": 10,
                        "Account": "7777004512345678",
                        "TransactionId": "00002352342"
                    }
                }, {
                        Header: 'Success - copy amount from request',
                        Json: {
                            "Message": "APPROVED",
                            "AuditNumber": "[COPY]",
                            "TransactionId": "[GEN_STRING_15]",
                            "AuthorizedAmount": "[AMOUNT]",
                            "Balance": 100.23
                        }
                    }, {
                        Header: 'Return error INVALID_MCHT_ACCT',
                        Json: {
                            "Error": {
                                "Message": "The merchant account is invalid",
                                "Code": "INVALID_MCHT_ACCT"
                            },
                            "AuthorizedAmount": 0,
                            "Balance": 100.25,
                            "TransactionId": "[GEN_STRING_15]"
                        }
                    }]
            },
            Reload: {
                APIDoc: {
                    Request: {
                        "MerchantId": "0123456789AB",
                        "TerminalId": "0015",
                        "AuditNumber": "0003",
                        "EntryMode": "track1",
                        "CardPresence": "present",
                        "TrackData": "B6010123456789012^TEST GIFT CARD^00010004000070002886",
                        "Amount": 100,
                        "Type": "Reload",
                        "ExpirationDate": "0119"
                    },
                    Response: {
                        "Message": "APPROVED",
                        "AuditNumber": "0003",
                        "AuthorizationNumber": "123459",
                        "TransactionId": "00002352343",
                        "Balance": 200.25,
                        "Account": "7777004512345678"
                    }
                },
                Examples: [{
                    Header: 'Return error UNSUPPORTED_TRAN',
                    Json: {
                        "Error": {
                            "Message": "The transaction type is not supported",
                            "Code": "UNSUPPORTED_TRAN"
                        },
                        "Balance": 100.25,
                        "TransactionId": "[GEN_STRING_15]"
                    }
                }, {
                        Header: 'Success - copy Amount from request',
                        Json: {
                            "Message": "APPROVED",
                            "AuditNumber": "[COPY]",
                            "AuthorizationNumber": "[GEN_STRING_8]",
                            "TransactionId": "[GEN_STRING_15]",
                            "AuthorizedAmount": "[AMOUNT]",
                            "Balance": 100.25
                        }
                    }]
            },
            Balance: {
                APIDoc: {
                    Request: {
                        "MerchantId": "0123456789AB",
                        "TerminalId": "0015",
                        "AuditNumber": "0004",
                        "EntryMode": "track1",
                        "CardPresence": "present",
                        "Account": "7777004512345678",
                        "ExpirationDate": "0119"
                    },
                    Response: {
                        "Message": "APPROVED",
                        "AuditNumber": "0004",
                        "Balance": 200.25,
                        "TransactionId": "00002352344"
                    }
                },
                Examples: [{
                    Header: 'Return error INVALID_FORMAT',
                    Json: {
                        "Error": {
                            "Message": "The format for the transaction is invalid",
                            "Code": "INVALID_FORMAT"
                        },
                        "Balance": 100.25
                    }
                }, {
                        Header: 'Success - static value 100.25',
                        Json: {
                            "Message": "APPROVED",
                            "AuditNumber": "[COPY]",
                            "Balance": 100.25
                        }
                    }]
            },
            Void: {
                APIDoc: {
                    Request: {
                        "MerchantId": "0123456789AB",
                        "TerminalId": "0015",
                        "AuditNumber": "0005",
                        "OriginalTransaction": "reload",
                        "TransactionId": "00002352343"
                    },
                    Response: {
                        "Message": "APPROVED",
                        "AuditNumber": "0005",
                        "Balance": 100.25
                    }
                },
                Examples: [{
                    Header: 'Return error UNSUPPORTED_TRAN',
                    Json: {
                        "Error": {
                            "Message": "The transaction type is not supported",
                            "Code": "UNSUPPORTED_TRAN"
                        }
                    }
                }, {
                        Header: 'Success',
                        Json: {
                            "Message": "APPROVED",
                            "AuditNumber": "[COPY]",
                            "Balance": 100.25
                        }
                    }]
            },
            Tor: {
                APIDoc: {
                    Request: {
                        "MerchantId": "0123456789AB",
                        "TerminalId": "0015",
                        "AuditNumber": "0006",
                        "EntryMode": "track1",
                        "CardPresence": "present",
                        "Amount": 10,
                        "TrackData": "B6010123456789012^TEST GIFT CARD^00010004000070002886",
                        "ExpirationDate": "0119",
                        "OriginalTransaction": "redeem"
                    },
                    Response: {
                        "Message": "APPROVED",
                        "AuditNumber": "0006",
                        "Balance": 105.75
                    }
                },
                Examples: [{
                    Header: 'Return error GEN_FAIL',
                    Json: {
                        "Error": {
                            "Message": "The transaction failed",
                            "Code": "GEN_FAIL"
                        }
                    }
                }, {
                        Header: 'Success',
                        Json: {}
                    }]
            }
        };

        var d: any = [];
        if (this.props.type) {
            if (this.state.isAPIDoc) {
                d.push({
                    Header: 'Request',
                    Data: this.toJson(data[this.props.type].APIDoc.Request)
                });
                d.push({
                    Header: 'Response',
                    Data: this.toJson(data[this.props.type].APIDoc.Response)
                });
            } else {
                data[this.props.type].Examples.map(function (j: any, idx: number) {
                    d.push({
                        Header: j.Header,
                        Data: this.toJson(j.Json)
                    });
                }, this);
            }
        }

        return (
            <div className="row panel panel-default mainGridHeader">
                <ul className="nav nav-tabs">
                    <li className={this.state.isAPIDoc ? "active" : ""}><a onClick={this.handleTabClick.bind(this, true) }>API Documentation</a></li>
                    <li className={this.state.isAPIDoc ? "" : "active"}><a onClick={this.handleTabClick.bind(this, false) }>Response Examples</a></li>
                </ul>
                <ul className="nav nav-tabs nav-tabs-pf">
                </ul>
                <div className="form-group" style={{ margin: "5px" }}>
                    {
                        d.map(function (t: any, idx: any) {
                            return (
                                <div className="col-md-5" key={idx}>
                                    <h4>{t.Header}</h4>
                                    <textarea className="form-control" cols={100} rows={30} readOnly={true} value={t.Data} style={{ height: "200px" }} />
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/ConfigurationHelp.tsx